import apiClient from './client'
import type { ReceptionRecord, StatsResponse } from '../types'

export const receptionApi = {
  getList: async (
    skip = 0,
    limit = 100,
    filters?: {
      start_date?: string
      end_date?: string
      case_type?: string
    }
  ): Promise<ReceptionRecord[]> => {
    return apiClient.get('/receptions', { params: { skip, limit, ...filters } })
  },

  getById: async (id: number): Promise<any> => {
    return apiClient.get(`/receptions/${id}`)
  },

  export: async (
    filters?: {
      start_date?: string
      end_date?: string
      case_type?: string
    }
  ): Promise<Blob> => {
    return apiClient.post('/receptions/export', filters, {
      responseType: 'blob',
    })
  },

  getStats: async (months = 6): Promise<StatsResponse> => {
    return apiClient.get('/receptions/stats', { params: { months } })
  },
}

export default receptionApi
